/* tslint:disable */
/* eslint-disable */
/**
 * NETS(EFT) Authentication API
 * \"This module is used to authenticate user and maintain session tokens  \"
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface JwtAuthenticationResponse
 */
export interface JwtAuthenticationResponse {
    /**
     * 
     * @type {string}
     * @memberof JwtAuthenticationResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof JwtAuthenticationResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {number}
     * @memberof JwtAuthenticationResponse
     */
    'systemAdminRoleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof JwtAuthenticationResponse
     */
    'tokenType'?: string;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface LogoutRequest
 */
export interface LogoutRequest {
    /**
     * 
     * @type {string}
     * @memberof LogoutRequest
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface NewUserRequestDto
 */
export interface NewUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof NewUserRequestDto
     */
    'adminUserName'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewUserRequestDto
     */
    'adminUserPassword'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewUserRequestDto
     */
    'effectiveDateUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewUserRequestDto
     */
    'expirationDateUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewUserRequestDto
     */
    'newUserName'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewUserRequestDto
     */
    'newUserPassword'?: string;
    /**
     * 
     * @type {number}
     * @memberof NewUserRequestDto
     */
    'systemAdminRoleId'?: number;
}
/**
 * 
 * @export
 * @interface NewUserResponseDto
 */
export interface NewUserResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof NewUserResponseDto
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TokenInvalidateResponse
 */
export interface TokenInvalidateResponse {
    /**
     * 
     * @type {string}
     * @memberof TokenInvalidateResponse
     */
    'invalidationStatus'?: string;
}
/**
 * 
 * @export
 * @interface TokenRequest
 */
export interface TokenRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    'refreshToken'?: string;
}
/**
 * 
 * @export
 * @interface TokenValidationResponse
 */
export interface TokenValidationResponse {
    /**
     * 
     * @type {string}
     * @memberof TokenValidationResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenValidationResponse
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenValidationResponse
     */
    'validationStatus'?: string;
}

/**
 * AuthCallBackControllerApi - axios parameter creator
 * @export
 */
export const AuthCallBackControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary generateEftAuthToken
         * @param {string} code code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEftAuthTokenUsingGET: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('generateEftAuthTokenUsingGET', 'code', code)
            const localVarPath = `/callbackeft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthCallBackControllerApi - functional programming interface
 * @export
 */
export const AuthCallBackControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthCallBackControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary generateEftAuthToken
         * @param {string} code code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateEftAuthTokenUsingGET(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateEftAuthTokenUsingGET(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthCallBackControllerApi - factory interface
 * @export
 */
export const AuthCallBackControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthCallBackControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary generateEftAuthToken
         * @param {string} code code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEftAuthTokenUsingGET(code: string, options?: any): AxiosPromise<object> {
            return localVarFp.generateEftAuthTokenUsingGET(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthCallBackControllerApi - object-oriented interface
 * @export
 * @class AuthCallBackControllerApi
 * @extends {BaseAPI}
 */
export class AuthCallBackControllerApi extends BaseAPI {
    /**
     * 
     * @summary generateEftAuthToken
     * @param {string} code code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthCallBackControllerApi
     */
    public generateEftAuthTokenUsingGET(code: string, options?: AxiosRequestConfig) {
        return AuthCallBackControllerApiFp(this.configuration).generateEftAuthTokenUsingGET(code, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MonitoringControllerApi - axios parameter creator
 * @export
 */
export const MonitoringControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitoring/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitoringControllerApi - functional programming interface
 * @export
 */
export const MonitoringControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitoringControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck2UsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck2UsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MonitoringControllerApi - factory interface
 * @export
 */
export const MonitoringControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitoringControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.healthCheck2UsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MonitoringControllerApi - object-oriented interface
 * @export
 * @class MonitoringControllerApi
 * @extends {BaseAPI}
 */
export class MonitoringControllerApi extends BaseAPI {
    /**
     * 
     * @summary healthCheck2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringControllerApi
     */
    public healthCheck2UsingGET(options?: AxiosRequestConfig) {
        return MonitoringControllerApiFp(this.configuration).healthCheck2UsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceStatusControllerApi - axios parameter creator
 * @export
 */
export const ServiceStatusControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/entityCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/profileCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceStatusControllerApi - functional programming interface
 * @export
 */
export const ServiceStatusControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceStatusControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entityCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entityCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceStatusControllerApi - factory interface
 * @export
 */
export const ServiceStatusControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceStatusControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.entityCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.healthCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.profileCheckUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceStatusControllerApi - object-oriented interface
 * @export
 * @class ServiceStatusControllerApi
 * @extends {BaseAPI}
 */
export class ServiceStatusControllerApi extends BaseAPI {
    /**
     * 
     * @summary entityCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public entityCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).entityCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary healthCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public healthCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).healthCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary profileCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public profileCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).profileCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TokenControllerApi - axios parameter creator
 * @export
 */
export const TokenControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/token/healthcheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary extendToken
         * @param {TokenRequest} tokenReq tokenReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendTokenUsingPOST: async (tokenReq: TokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenReq' is not null or undefined
            assertParamExists('extendTokenUsingPOST', 'tokenReq', tokenReq)
            const localVarPath = `/token/extendToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateToken
         * @param {LoginRequest} loginRequest loginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTokenUsingPOST: async (loginRequest: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('generateTokenUsingPOST', 'loginRequest', loginRequest)
            const localVarPath = `/token/generateToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary invalidateToken
         * @param {LogoutRequest} logoutrequest logoutrequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateTokenUsingPOST: async (logoutrequest: LogoutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logoutrequest' is not null or undefined
            assertParamExists('invalidateTokenUsingPOST', 'logoutrequest', logoutrequest)
            const localVarPath = `/token/inValidateToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logoutrequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary validateAccessToken
         * @param {TokenRequest} tokenValReq tokenValReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAccessTokenUsingPOST: async (tokenValReq: TokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenValReq' is not null or undefined
            assertParamExists('validateAccessTokenUsingPOST', 'tokenValReq', tokenValReq)
            const localVarPath = `/token/validateAccesToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenValReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenControllerApi - functional programming interface
 * @export
 */
export const TokenControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseSvcUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseSvcUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary extendToken
         * @param {TokenRequest} tokenReq tokenReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendTokenUsingPOST(tokenReq: TokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JwtAuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendTokenUsingPOST(tokenReq, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateToken
         * @param {LoginRequest} loginRequest loginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTokenUsingPOST(loginRequest: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JwtAuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTokenUsingPOST(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary invalidateToken
         * @param {LogoutRequest} logoutrequest logoutrequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateTokenUsingPOST(logoutrequest: LogoutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenInvalidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateTokenUsingPOST(logoutrequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary validateAccessToken
         * @param {TokenRequest} tokenValReq tokenValReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAccessTokenUsingPOST(tokenValReq: TokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAccessTokenUsingPOST(tokenValReq, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokenControllerApi - factory interface
 * @export
 */
export const TokenControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.baseSvcUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary extendToken
         * @param {TokenRequest} tokenReq tokenReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendTokenUsingPOST(tokenReq: TokenRequest, options?: any): AxiosPromise<JwtAuthenticationResponse> {
            return localVarFp.extendTokenUsingPOST(tokenReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateToken
         * @param {LoginRequest} loginRequest loginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTokenUsingPOST(loginRequest: LoginRequest, options?: any): AxiosPromise<JwtAuthenticationResponse> {
            return localVarFp.generateTokenUsingPOST(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary invalidateToken
         * @param {LogoutRequest} logoutrequest logoutrequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateTokenUsingPOST(logoutrequest: LogoutRequest, options?: any): AxiosPromise<TokenInvalidateResponse> {
            return localVarFp.invalidateTokenUsingPOST(logoutrequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary validateAccessToken
         * @param {TokenRequest} tokenValReq tokenValReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAccessTokenUsingPOST(tokenValReq: TokenRequest, options?: any): AxiosPromise<TokenValidationResponse> {
            return localVarFp.validateAccessTokenUsingPOST(tokenValReq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokenControllerApi - object-oriented interface
 * @export
 * @class TokenControllerApi
 * @extends {BaseAPI}
 */
export class TokenControllerApi extends BaseAPI {
    /**
     * 
     * @summary baseSvc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenControllerApi
     */
    public baseSvcUsingGET(options?: AxiosRequestConfig) {
        return TokenControllerApiFp(this.configuration).baseSvcUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary extendToken
     * @param {TokenRequest} tokenReq tokenReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenControllerApi
     */
    public extendTokenUsingPOST(tokenReq: TokenRequest, options?: AxiosRequestConfig) {
        return TokenControllerApiFp(this.configuration).extendTokenUsingPOST(tokenReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateToken
     * @param {LoginRequest} loginRequest loginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenControllerApi
     */
    public generateTokenUsingPOST(loginRequest: LoginRequest, options?: AxiosRequestConfig) {
        return TokenControllerApiFp(this.configuration).generateTokenUsingPOST(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary invalidateToken
     * @param {LogoutRequest} logoutrequest logoutrequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenControllerApi
     */
    public invalidateTokenUsingPOST(logoutrequest: LogoutRequest, options?: AxiosRequestConfig) {
        return TokenControllerApiFp(this.configuration).invalidateTokenUsingPOST(logoutrequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary validateAccessToken
     * @param {TokenRequest} tokenValReq tokenValReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenControllerApi
     */
    public validateAccessTokenUsingPOST(tokenValReq: TokenRequest, options?: AxiosRequestConfig) {
        return TokenControllerApiFp(this.configuration).validateAccessTokenUsingPOST(tokenValReq, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserManagementControllerApi - axios parameter creator
 * @export
 */
export const UserManagementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary newUser
         * @param {NewUserRequestDto} newUserRequestDto newUserRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newUserUsingPOST: async (newUserRequestDto: NewUserRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newUserRequestDto' is not null or undefined
            assertParamExists('newUserUsingPOST', 'newUserRequestDto', newUserRequestDto)
            const localVarPath = `/userManagement/newUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newUserRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserManagementControllerApi - functional programming interface
 * @export
 */
export const UserManagementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserManagementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary newUser
         * @param {NewUserRequestDto} newUserRequestDto newUserRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newUserUsingPOST(newUserRequestDto: NewUserRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewUserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newUserUsingPOST(newUserRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserManagementControllerApi - factory interface
 * @export
 */
export const UserManagementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserManagementControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary newUser
         * @param {NewUserRequestDto} newUserRequestDto newUserRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newUserUsingPOST(newUserRequestDto: NewUserRequestDto, options?: any): AxiosPromise<NewUserResponseDto> {
            return localVarFp.newUserUsingPOST(newUserRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserManagementControllerApi - object-oriented interface
 * @export
 * @class UserManagementControllerApi
 * @extends {BaseAPI}
 */
export class UserManagementControllerApi extends BaseAPI {
    /**
     * 
     * @summary newUser
     * @param {NewUserRequestDto} newUserRequestDto newUserRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementControllerApi
     */
    public newUserUsingPOST(newUserRequestDto: NewUserRequestDto, options?: AxiosRequestConfig) {
        return UserManagementControllerApiFp(this.configuration).newUserUsingPOST(newUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


